import { CurrencyType, SystemCurrency } from '@okletsplay/core';
import { GameActivityPaymentConfig } from '../interfaces';

export const DEFAULT_GAME_ACTIVITY_PAYMENT_CONFIG: GameActivityPaymentConfig = {
  mainCurrency: SystemCurrency.USDT,
  platformFeeCurrency: SystemCurrency.OKLP,
  isPlatformFeeApplied: true,
  exchangeRate: 0,
  currencyType: CurrencyType.USDT_OKLP,
};
